import styled from "styled-components";
import { Row } from "react-bootstrap";
import BoxesImg from "../../../assets/img/Work-flow.png";
import { PRIMARY_KUBBE, DARK_KUBBE } from "../../../constants/Colors";

const SectionWrapper = styled.section`
  width: 100%;
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  background-color: ${PRIMARY_KUBBE};
  color: ${DARK_KUBBE};
  font-weight: 900;
  font-size: 1.8rem;
  border-radius: 10px;
  padding: 10px 30px;
  margin-bottom: 2rem;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ContentWrapper = styled(Row)`
  position: relative;
  width: 100%;
  max-width: 800px;
  aspect-ratio: 1.22;
  margin-bottom: 2rem;
`;

const StepList = styled.ul`
  position: absolute;
  top: 10%;
  left: 10%;
  width: 50%;
  height: 55%;
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  li {
    display: flex;
    align-items: flex-start;
    font-weight: 600;
    font-size: clamp(0.5rem, 2vw, 25px);
    @media (max-width: 768px) {
      font-size: 1rem;
      font-size: clamp(0.5rem, 2.5vw, 25px);
    }
  }
`;

const BoxesImage = styled.img`
  width: 100%;
  max-width: 800px;
`;

const FlowSection = () => {
  return (
    <SectionWrapper>
      <Title>ASÍ FUNCIONA BUENA RUTA</Title>

      <ContentWrapper className="justify-content-center">
        <BoxesImage src={BoxesImg} alt="Decoración con cajas y granos" />

        <StepList>
          <li>Dadores de carga publican sus necesidades logísticas</li>
          <li>
            Transportistas validados reciben
            <br /> las ofertas disponibles
          </li>
          <li>
            Ambas partes eligen la opción
            <br /> más conveniente.
          </li>
          <li>
            Coordinan, transportan y<br /> entregan con seguimiento
            <br /> digital
          </li>
        </StepList>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default FlowSection;
